import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import i18n from "../i18n";

const useKeycloakData = () => {

  const { initialized, keycloak } = useKeycloak();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [language, setLanguage] = useState("en-EN");
  
  //For statuses
  const [email, setEmail] = useState("");
  const [keycloakRoles, setKeycloakRoles] = useState([]);


  useEffect(() => {
    if (initialized) {
      console.log("KEYCLOAK DATA PARSE", { keycloak });

      //GET FROM KEYCLOAK SERVER
      setFirstName(keycloak?.tokenParsed?.given_name || "NO GIVEN NAME");
      setLastName(keycloak?.tokenParsed?.family_name || "NO FAMILY NAME");
      setEmail(keycloak?.tokenParsed?.email);
      setKeycloakRoles(keycloak?.realmAccess?.roles);

      //SET LANGUAGE FROM KEYCLOAK
      //setLanguage(keycloak?.tokenParsed?.locale || "en-EN");

    }
  }, [initialized]);

  /* useEffect(() => {
    //console.log({language: language})
    i18n.changeLanguage(language);
  }, [language]); */

  return {
    firstName,
    lastName,
    email,
    keycloak,
    language,
    keycloakRoles,
  };
};

export default useKeycloakData;
